/**
 * 找回密码实体
 */

import { Component, useState, useEffect } from 'react';
import $ from 'jquery';
import {
    Row,
    Col,
    Steps,
    Button,
    Input,
    Progress,
    message,
} from 'antd';
import CNF from '../../incs/Config.js';
import {
    CheckOutlined,
    CheckCircleOutlined,
    SolutionOutlined,
    EditOutlined
} from '@ant-design/icons';
import {
    rff,
    DeleteCookies,
    isGTscreenWidth,
    UjoinParams,
} from '../../incs/FunHelper.js';

/**
 * 第一步
 * 验证账户
 */
class VerifyAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            verifyId: '',
            account: '',
            systemAccount: '',
            aMsg: '',   //  账户错误提示
            verfiyCode: '',
            vMsg: '',   //  验证码错误提示
            isSendVerifyCode: 0,
            vTime: 0,
            bTitle: '获取验证码',
            loading: false
        }
    }
    //  账户
    changeAccount = (e) => { this.setState({ account: e.target.value, aMsg: '' }); }
    //  验证码
    changeVerifyCode = (e) => {
        this.setState({
            verfiyCode: e.target.value,
            loading: false
        });
    }

    changeVTime = (t) => { this.setState({ vTime: t }); }

    /**
     * 验证账户
     * @returns 
     */
    verifyAccount = () => {
        const account = this.state.account;
        if (this.props.method === 'phone') {
            // 手机格式校验
            let rex = CNF.regex.phone.exec(account);
            if (rex === null || rex[0] !== account) {
                this.setState({ aMsg: '手机号格式错误！' });
                return;
            }
        } else if (this.props.method === 'email') {
            // 邮箱格式校验
            let rex = CNF.regex.email.exec(account);
            if (rex === null || rex[0] !== account) {
                this.setState({ aMsg: '邮箱格式错误！' });
                return;
            }
        } else {
            return;
        }

        // 发送请求验证账户
        const _this = this;
        let data = {
            'type': this.props.method,
        };
        if (this.props.method === 'phone') {
            data['phone'] = account;
        } else {
            data['email'] = account;
        }
        $.ajax({
            url: `${CNF.api}users/noTokenVerifyinfo${UjoinParams(data)}`,
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.account) {
                        _this.setState({
                            verifyId: data.dat.verify_id,
                            account: data.dat.account,
                            systemAccount: data.dat.account,
                        });
                        _this.sendVerifyCode(data.dat.verify_id, data.dat.account);
                    } else {
                        _this.setState({
                            verifyId: data.dat.verify_id,
                            aMsg: (_this.props.method === 'phone' ? '手机' : '邮箱') + '不存在！',
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /**
     * 发送验证码
     * @param {*} verifyId 
     * @param {*} account
     */
    sendVerifyCode = (verifyId, account) => {
        this.setState({ vTime: 60, isSendVerifyCode: 0 });
        const _this = this;
        let data = {
            'method': this.props.method,
            'verify_id': verifyId,
            'account': account,
        }
        $.ajax({
            url: `${CNF.api}users/noTokenSendVerifyCode${UjoinParams(data)}`,
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    _this.setState({ isSendVerifyCode: 1 });
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /***
     * 通过验证码验证身份
     */
    verifyVCode = () => {
        var rex = CNF.regex.verifyCode.exec(this.state.verfiyCode);
        if (rex === null || rex[0] !== this.state.verfiyCode) {
            this.setState({ vMsg: '验证码格式错误！' });
            return;
        }
        this.setState({ loading: true });
        const _this = this;
        let data = {
            'verify_id': this.state.verifyId,
            'account': this.state.account,
            'verify_code': this.state.verfiyCode
        }
        $.ajax({
            url: `${CNF.api}users/noTokenVerifyVerifyCode${UjoinParams(data)}`,
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    _this.props.changeVerifyFingerprint(data.dat);
                    _this.props.changeAccount(_this.state.account);
                    _this.props.changeStatus(2);
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    render() {
        return (
            <>
                <Row style={{ marginTop: '40px' }}>
                    <Col span={14} offset={5}>
                        <label>{this.props.method === 'phone' ? '手机' : '邮箱'}验证账户 <span style={{ color: '#EF6730' }}>{this.props.username}</span> 为确保是您本人操作, 请完成以下验证: </label>
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={2} offset={5}>
                        <label>{rff}{this.props.method === 'phone' ? '手机' : '邮箱'}: </label>
                    </Col>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        {
                            this.state.systemAccount && this.state.systemAccount === this.state.account ? (
                                <Button
                                    disabled={true}
                                    style={{
                                        backgroundColor: '#EF6730',
                                        color: '#fff',
                                        borderRadius: 0,
                                        border: 0,
                                        cursor: 'default',
                                    }} >{this.state.account}</Button>
                            ) : (
                                <Input
                                    value={this.state.account}
                                    onChange={this.changeAccount}
                                    placeholder={'请输入' + (this.props.method === 'phone' ? '手机' : '邮箱')}
                                    style={{ borderRadius: 0, width: '100%' }}
                                />
                            )
                        }
                    </Col>
                    <Col span={4}><div style={{ color: 'red', marginLeft: '10px' }}>{this.state.aMsg}</div></Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={2} offset={5}>
                        <label>{rff}验证码: </label>
                    </Col>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Input
                            value={this.state.verfiyCode}
                            onChange={this.changeVerifyCode}
                            placeholder='请输入验证码'
                            style={{ borderRadius: 0, width: '100%' }}
                        />
                    </Col>
                    <Col span={4}>
                        <Button
                            block={true}
                            type='primary'
                            style={{ backgroundColor: '#EF6730', borderRadius: 0, border: 0, marginLeft: '10px' }}
                            disabled={this.state.vTime > 0 ? true : false}
                            onClick={() => {
                                this.verifyAccount();
                            }}><BTitle vTime={this.state.vTime} changeVTime={this.changeVTime} />
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col span={12} offset={7}>
                        <div style={{ fontSize: '12px', color: '#B2B2B2', visibility: this.state.isSendVerifyCode > 0 ? '' : 'hidden' }}>
                            <CheckCircleOutlined /> 验证码已发送到您的{this.props.method === 'phone' ? '手机' : '邮箱'}, 15分钟内输入有效, 验证码等同于密码, 打死也不能告诉别人哦！
                        </div>
                    </Col>
                </Row>
                <Row style={{ marginTop: '25px' }}>
                    <Col span={2} offset={5}>
                        <Button
                            block={true}
                            type='primary'
                            style={{ backgroundColor: '#2A8BD5', borderRadius: 0, border: 0 }}
                            disabled={!this.state.systemAccount || !this.state.verfiyCode ? true : this.state.loading}
                            onClick={() => {
                                this.verifyVCode();
                            }}>马上验证
                        </Button>
                    </Col>
                    <Col span={4}><span style={{ color: 'red', marginLeft: '10px', lineHeight: '30px' }}>{this.state.vMsg}</span></Col>
                </Row>
                <Row style={{ marginTop: '40px' }}>
                    {
                        this.props.method === '手机号码' ? (
                            <Col span={18} offset={5} style={{ fontSize: '12px' }}>
                                <p style={{ fontSize: '16px', fontWeight: 'bold' }}>没收到短信验证码？</p>
                                <p>1、网络通讯异常可能会造成短信丢失, 请重新获取或稍后再试。</p>
                                <p>2、请核实手机是否已欠费停机, 或者屏蔽了系统短信。</p>
                                <p>3、如果手机已丢失或停用,  请选择其他验证方式 。</p>
                                <p>4、您也可以尝试将SIM卡移动到另一部手机, 然后重试。</p>
                            </Col>
                        ) : (
                            <Col span={18} offset={5} style={{ fontSize: '12px' }}>
                                <p style={{ fontSize: '16px', fontWeight: 'bold' }}>没收到邮件验证码？</p>
                                <p>1、网络异常可能会造成邮件丢失, 请重新获取或稍后再试。</p>
                                <p>2、检查邮件收信规则设置, 检查收信条件是否设置不当。</p>
                                <p>3、检查反垃圾设置, 黑名单中是否误加入了正常邮箱地址 。</p>
                                <p>4、或者在垃圾邮件中查找看看。</p>
                            </Col>
                        )
                    }
                </Row>
            </>
        )
    }
}

/***
 * 控制获取验证码按钮文字显示
 */
class BTitle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: '获取验证码'
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const _this = this;
        if (nextProps.vTime > 0) {
            setTimeout(function () {
                _this.props.changeVTime(nextProps.vTime - 1);
            }, 1000);
            _this.setState({ title: nextProps.vTime - 1 + 's 后, 可重新获取验证码' });
        }
        if (nextProps.vTime < 1) {
            _this.setState({ title: '获取验证码' });
        }
    }

    render() {
        return (
            <span style={{ color: '#fff' }}>{this.state.title}</span>
        )
    }
}

/**
 * 第二步
 * 修改密码
 */
class PasswordS2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
            verifyPassword: '',
            msg: '',
            loading: false,
            pStrength: 0,
            c1: '#BFBFBF',
            c2: '#BFBFBF',
            c3: '#BFBFBF'
        }
    }

    getPasswordType(value) {
        var s = 0;
        // 是否包含数字
        if (/([0-9])/.exec(value)) {
            s += 1;
        }
        //  是否包含小写字母
        if (/([a-z])/.exec(value)) {
            s += 1;
        }
        //  是否包含大写字母
        if (/([A-Z])/.exec(value)) {
            s += 1;
        }
        //  是否包含标点符号
        if (/([^0-9a-zA-Z])/.exec(value)) {
            s += 1;
        }
        return s;
    }

    verifyPasswordStrength(value) {
        /***
         * 验证密码强度
         * 1、密码必须在 6~20 个字符之间
         * 2、只能包含大小写字母、数字、下滑线及标点符号（空格除外）
         * 3、大写字母、小写字母、数字及标点符号至少包含 2 种及以上
         * 
         * 密码强弱判断
         * 通过权重判断
         * 1、长度 < 8 w += 1
         * 2、长度 >= 8 w += 2
         * 3、2 种类型 w += 1
         * 4、3 种类型 w += 2
         * 5、4 种类型 w += 3
         * 6 w <= 2 pStrength=1
         * 7 w > 2 && w <=4 pStrength=2
         * 8 w > 4 pStrength=3
         */

        var w = 0;
        if (value.length >= 8) {
            w += 1;
        }

        var s = this.getPasswordType(value);
        if (s < 2) {
            w += 1;
        } else if (s > 3) {
            w += 3;
        } else {
            w += 2;
        }

        var pStrength = 1;
        if (w > 3) {
            pStrength = 3;
        } else if (w > 1 && w < 4) {
            pStrength = 2;
        }

        this.setState({ pStrength: pStrength });
    }

    changPassword = (e) => {
        this.setState({
            loading: false,
            msg: '', //  用于密码格式错误信息！
            password: e.target.value.replace(' ', '')
        });
        if (e.target.value.replace(' ', '').length >= 6) {
            this.verifyPasswordStrength(e.target.value.replace(' ', ''));
        }
    }

    changeVerifyPassword = (e) => {
        this.setState({
            loading: false,
            msg: '',
            verifyPassword: e.target.value
        });
    }

    updatePassword() {
        const password = this.state.password;
        if (password.length < 6 ||
            password.length > 20 ||
            this.getPasswordType(password) < 2 ||
            !CNF.regex.password.exec(password)) {
            this.setState({
                msg: '密码格式错误！'
            });
            return;
        }

        if (password !== this.state.verifyPassword) {
            this.setState({
                msg: '两次输入密码不一致！'
            });
            return;
        }

        const _this = this;
        this.setState({ loading: true });

        $.ajax({
            url: CNF.api + 'users/noTokenSecurityinfo',
            type: 'PATCH',
            dataType: 'JSON',
            contentType: 'application/json',
            data: JSON.stringify({
                'account': this.props.account,
                'verify_fingerprint': this.props.verifyFingerprint,
                'password': this.state.password,
            }),
        }).done((data) => {
            if (data.res === 0) {
                _this.props.changeStatus(3);
            } else {
                _this.setState({ loading: false });
                message.error(data.msg, CNF.messageDuration);
            }
        });
    }

    componentDidUpdate() {
        var c1 = '#BFBFBF';
        var c2 = '#BFBFBF';
        var c3 = '#BFBFBF';
        switch (this.state.pStrength) {
            case 1:
                c1 = 'red';
                break;
            case 2:
                c1 = '#EF6730';
                c2 = '#EF6730';
                break;
            case 3:
                c1 = 'green';
                c2 = 'green';
                c3 = 'green';
                break;
            default:
                break;
        }
        if (this.state.c1 !== c1 || this.state.c2 !== c2 || this.state.c3 !== c3) {
            this.setState({
                c1: c1,
                c2: c2,
                c3: c3
            });
        }
    }

    render() {
        return (
            <div>
                <Row style={{ marginTop: '40px' }}>
                    <Col span={14} offset={5}>
                        <label>重置账户 <span style={{ color: '#EF6730' }}>{this.props.account}</span> 密码, 请完成修改。</label>
                    </Col>
                </Row>
                <Row style={{ marginTop: '20px', fontSize: '12px' }}>
                    <Col span={14} offset={5}>
                        <p>1、密码必须在 6~20 个字符之间</p>
                        <p>2、只能包含大小写字母、数字、下滑线及标点符号（空格除外）</p>
                        <p>3、大写字母、小写字母、数字及标点符号至少包含 2 种及以上</p>
                    </Col>
                </Row>
                <Row style={{ marginTop: '20px' }}>
                    <Col span={3} offset={5}>
                        <Input
                            value={this.state.password}
                            onChange={this.changPassword}
                            type={'password'}
                            placeholder='请输入新密码'
                            style={{ borderRadius: 0 }}
                        />
                    </Col>
                    <Col span={4} style={{ marginLeft: '10px', lineHeight: '30px', color: 'red' }}>
                        {
                            this.state.password === '' ? (<span>*</span>) : (
                                <div>
                                    <Progress strokeColor={this.state.c1} style={{ float: 'left', width: '30px' }} showInfo={false} strokeLinecap='square' percent={100} />
                                    <Progress strokeColor={this.state.c2} style={{ float: 'left', marginLeft: '5px', width: '30px' }} showInfo={false} strokeLinecap='square' percent={100} />
                                    <Progress strokeColor={this.state.c3} style={{ float: 'left', marginLeft: '5px', width: '30px' }} showInfo={false} strokeLinecap='square' percent={100} />
                                </div>
                            )
                        }
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={3} offset={5}>
                        <Input
                            value={this.state.verifyPassword}
                            onChange={this.changeVerifyPassword}
                            type={'password'}
                            placeholder='请再次输入新密码'
                            style={{ borderRadius: 0 }}
                        />
                    </Col>
                    <Col span={4} style={{ marginLeft: '10px', lineHeight: '30px', color: 'red' }}><span>*</span></Col>
                </Row>
                <Row style={{ marginTop: '30px' }}>
                    <Col span={3} offset={5}>
                        <Button
                            block={true}
                            type='primary'
                            style={{ backgroundColor: '#EF6730', borderRadius: 0, border: 0, width: '100%' }}
                            disabled={this.state.loading}
                            onClick={() => {
                                this.updatePassword();
                            }}>马上重置</Button>
                    </Col>
                    <Col span={4} style={{ marginLeft: '10px', lineHeight: '30px', color: 'red' }}><span>{this.state.msg}</span></Col>
                </Row>
            </div>
        )
    }
}

/**
 * 第三步
 * 完成修改
 */
const UpdateS3 = (props) => {
    return (
        <>
            <Row style={{ marginTop: '40px' }}>
                <Col span={10} offset={5}>
                    <label>账户 <span style={{ color: '#EF6730' }}>{props.account}</span> {props.title}已完成, 是否？</label>
                </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col span={3} offset={5}>
                    <Button
                        block={true}
                        type='primary'
                        style={{ backgroundColor: '#EF6730', borderRadius: 0, border: 0 }}
                        onClick={() => {
                            DeleteCookies();
                        }}>重新登录</Button>
                </Col>
            </Row>
        </>
    )
}

/**
 * 第一步
 * 验证账户
 * 可以通过电话和邮件进行身份认证
 */
const Step = (props) => {
    const [s, SetS] = useState(0);


    useEffect(() => {
        SetS(props.s);
    }, [props.s]);


    const renderUpdateS1 = () => {
        // 第一步, 验证账户
        return (
            <VerifyAccount
                method={props.method}
                changeStatus={props.changeStatus}
                changeAccount={props.changeAccount}
                changeVerifyFingerprint={props.changeVerifyFingerprint}
            />
        );
    }

    const renderUpdateS2 = (account, verifyFingerprint) => {
        // 第二步, 修改密码
        return (
            <PasswordS2
                changeStatus={props.changeStatus}
                account={account}
                verifyFingerprint={verifyFingerprint}
            />
        );
    }

    const renderUpdateS3 = (account) => {
        return (
            <UpdateS3
                changeStatus={props.changeStatus}
                account={account}
                title={props.title}
            />
        );
    }

    if (s > 0) {
        switch (s) {
            case 1:
                return renderUpdateS1();
            case 2:
                return renderUpdateS2(props.account, props.verifyFingerprint);
            case 3:
                return renderUpdateS3(props.account);
            default:
                return null;
        }
    } else {
        return null;
    }

}

const Method = (props) => {
    return (
        <>
            <Row style={{ marginTop: '40px' }}>
                <Col span={14} offset={5}>
                    <p style={{ fontSize: '15px', fontWeight: 'bold' }}>为确保是您本人在操作, 请您选择验证方式完成身份认证: </p>
                </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col span={12} offset={5}>
                    <label style={{ fontSize: '20px' }}>通过 手机验证身份</label>
                    <p>如果您的手机还在正常使用, 可选择此方式。</p>
                </Col>
                <Col span={2} align='right'>
                    <Button
                        block={true}
                        type='primary'
                        style={{ backgroundColor: '#EF6730', borderRadius: 0, border: 0, marginTop: '25px' }}
                        onClick={() => {
                            props.changeMethod('phone');
                        }}>马上验证</Button>
                </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col span={12} offset={5}>
                    <label style={{ fontSize: '20px' }}>通过 邮箱验证身份</label>
                    <p>如果您的邮箱还在正常使用, 可选择此方式。</p>
                </Col>
                <Col span={2} align='right'>
                    <Button
                        block={true}
                        type='primary'
                        style={{ backgroundColor: '#EF6730', borderRadius: 0, border: 0, marginTop: '25px' }}
                        onClick={() => {
                            props.changeMethod('email');
                        }}>马上验证</Button>
                </Col>
            </Row>
        </>
    )

}

export default class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            securityInfo: {},
            s: 1,
            s1: 'process',
            s2: 'wait',
            s3: 'wait',
            method: '',
            account: '',
            verifyFingerprint: ''
        }
    }
    /**
     * 切换验证方式
     * @param {*} m 
     */
    changeMethod = (m) => { this.setState({ method: m }); }

    /**
     * 登录账户, 可以使手机或邮箱
     * @param {*} value 
     */
    changeAccount = (value) => { this.setState({ account: value }); }

    /**
     * 认证指纹
     * @param {*} value 
     */
    changeVerifyFingerprint = (value) => { this.setState({ verifyFingerprint: value }); }

    /**
     * 安全信息修改步骤, 总共3部
     * 1: 身份确认
     * 2: 执行修改
     * 3: 修改完成
     * @param {*} s 
     */
    changeStatus = (s) => {
        var s1 = 'process';
        var s2 = 'wait';
        var s3 = 'wait';
        switch (s) {
            case 2:
                s1 = 'finish';
                s2 = 'process';
                s3 = 'wait';
                break;
            case 3:
                s1 = 'finish';
                s2 = 'finish';
                s3 = 'process';
                break;
            default:
                break;
        }
        this.setState({
            s: s,
            s1: s1,
            s2: s2,
            s3: s3
        });
    }

    render() {
        return (
            <div>
                <Row>
                    <Col span={14} offset={5} style={{ marginTop: '40px' }}>
                        <Steps
                            items={[
                                {
                                    title: '验证账户',
                                    status: this.state.s1,
                                    icon: <SolutionOutlined />
                                },
                                {
                                    title: this.props.title,
                                    status: this.state.s2,
                                    icon: <CheckOutlined />
                                },
                                {
                                    title: '重置完成',
                                    status: this.state.s3,
                                    icon: <EditOutlined />
                                }
                            ]}
                        />
                    </Col>
                </Row>
                {
                    this.state.method === '' ? (
                        <Method
                            changeMethod={this.changeMethod}
                        />
                    ) : (
                        <Step
                            m={this.props.m}
                            s={this.state.s}
                            title={this.props.title}
                            method={this.state.method}
                            verifyFingerprint={this.state.verifyFingerprint}
                            changeVerifyFingerprint={this.changeVerifyFingerprint}
                            account={this.state.account}
                            changeAccount={this.changeAccount}
                            changeStatus={this.changeStatus}
                        />
                    )
                }
            </div>
        );
    }
}